import { Box, Card, Tab, Tabs } from "@mui/material";
import React, { FC, useState } from "react";

import Buttons from "./Buttons";
import Selects from "./Selects";
import Chips from "./Chips";
import Radios from "./Radios";
import Checkboxes from "./Checkboxes";
import Switches from "./Switches";
import TextFields from "./TextFields";
import Menu from "./Menu";
import Typography from "./Typography";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = (props: TabPanelProps): JSX.Element => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const a11yProps = (index: number): object => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const ComponentsPage: FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setValue(newValue);
  };

  const tabLabels = [
    "Buttons",
    "Chips",
    "Selects",
    "Menu",
    "Text Fields",
    "Checkboxes",
    "Radios",
    "Switches",
    "Typography",
  ];

  const tabComponents = [
    <Buttons />,
    <Chips />,
    <Selects />,
    <Menu />,
    <TextFields />,
    <Checkboxes />,
    <Radios />,
    <Switches />,
    <Typography />,
  ];

  return (
    <Card>
      <Box p={3}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            {tabLabels.map((label, index) => (
              <Tab key={label} label={label} {...a11yProps(index)} />
            ))}
          </Tabs>
        </Box>
        {tabComponents.map((Component, index) => (
          <CustomTabPanel key={index} value={value} index={index}>
            {Component}
          </CustomTabPanel>
        ))}
      </Box>
    </Card>
  );
};

export default ComponentsPage;
